export const FileManager = {
    // Notifications from the server on websocket
    SET_UPLOADED_FILES: "fileManager.set_uploaded_files",
};
